export enum PayoutFrequencyEnum {
  YEARLY = 'Yearly'
}
